import { createContext } from 'react';

import { TrackingProps } from '../../utils/interface';

interface TrackingContextProps extends TrackingProps {
  device_type: 'desktop' | 'mobile' | 'tablet' | 'tv' | null;
  campaignOverride?: string | null;
}

const TrackingContext = createContext<TrackingContextProps>({
  params: { upsell_name: '', page: '', feature: '', location: '', integration: '' },
  device_type: null,
  paywallTracking: {
    paywallTrigger: '',
    paywallLocation: '',
    paywallType: 'popup',
    paywallFeature: '',
  },
});

export default TrackingContext;
